/**
 * Created by rrahlf on 7/22/2016.
 */

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@/services/auth.service';
import { LocationService } from '@/services/location.service';
import { MessageService } from '@/services/message.service';
import { LocalStorageService } from '@/services/localStorage.service';
import { IAuthUser, UserRole } from '@/models/auth.models';
import { BaseSmartComponent } from './../base.component';
import {ILocationModel} from '@/models/location.models';
import {UserService} from '@/services/user.service';

@Component({
	selector: 'account-info',
	templateUrl: './accountInfo.template.html',
	host: {'class': 'account-info-component'}
})
export class AccountInfoComponent extends BaseSmartComponent implements OnInit {
	public model: IAuthUser;
  public locations: ILocationModel[];
  public activeLocationIds: string[] = [];
	public jobSource: string;
	public isShopForeman: Boolean = false;
	public isAdmin: Boolean = false;
	public isPresident: Boolean = false;
	public isVicePresident: Boolean = false;

	constructor(
		private authService: AuthService,
		private router: Router,
		messageService: MessageService,
		private locationService: LocationService,
		private localStorageService: LocalStorageService
	) {
    super(messageService);
	}

  public ngOnInit(): void {
    this.authService.currentUser.subscribe((user) => this.setUser(user));
    this.locationService.getLocations().then(locations => this.locations = locations);
  }

	logout(): void {
		this.authService.logout();
	}

	setUser(user: IAuthUser): void {
		this.model = user;
		if (this.model) {
			// set default job source to user's location
      this.activeLocationIds = this.model.locations?.map(l => l.locationId);
      const currentLocation = this.locations?.find(l => l.id === user.currentLocationId);
      if (currentLocation) {
        this.setJobSource(currentLocation.id, this.getLocationName(currentLocation));
        this.isShopForeman = this.model.role === UserRole.ShopForeman;
        this.isAdmin = this.model.role === UserRole.Admin;
        this.isPresident = this.model.role === UserRole.President;
        this.isVicePresident = this.model.role === UserRole.VicePresident;
      }
		}
	}

  getLocationName(location: ILocationModel): string {
    return location.name.replace('Klein-Dickert Milwaukee, Inc. - ', '');
  }

  async changeJobSource(id: string): Promise<void> {
		await this.authService.switchLocation(id);

		if (this.router.url.includes('Customers') && this.router.url.includes('/Job/')) {
			await this.router.navigate(['/Jobs']);
		}
  }

  getActiveLocations(): ILocationModel[] {
    return this.locations.filter(l => this.activeLocationIds?.includes(l.id));
  }

	private setJobSource(id: string, name: string): void {
    const currentJobSource = JSON.parse(localStorage.getItem('jobSource'));
    if (!currentJobSource || currentJobSource?.id !== id) {
      this.localStorageService.setItem('jobSource', JSON.stringify({ name, id  }));
      this.jobSource = name;
      if (this.isAdmin || this.isPresident || this.isVicePresident) {
        this.locationService.notifyLocationChanged('Now viewing ' + name + ' jobs.');
      }
    } else {
      this.jobSource = name;
    }
	}
}
